import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Button,
  Switch,
  Input,
  Select,
  Radio,
  DatePicker,
  Image,
  Checkbox,
  Layout,
  FloatButton,
  ConfigProvider,
  Spin,
} from "antd";
import moment from "moment";
import dayjs from "dayjs";
import { getUser } from "../../stored/mydata";
import apigetRoom from "../../api/home/getRoom";
import apigetIcons from "../../api/scene/getIcons";
import apigetScene from "../../api/scene/getScene";
import apiPostCreateSchedule from "../../api/schedule/postCreateSchedule";
import { ArrowLeftOutlined, LoadingOutlined } from "@ant-design/icons";
import Devicebox from "../../components/addschdule/devicebox";
import ScenePicture from "../../components/picture/sceneicon";
import setformatData from "../../api/setFormat_Data";
// import Room_deive from "./room_device";
import Room_deive from "../../components/schedule/schedule_edit_device";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";

const { Header, Content, Footer } = Layout;

export default function Schedule(props) {
  const myUser = useSelector(getUser);

  const windowWidth = useRef(window.innerWidth);

  const [btnwidth, setBtnwidth] = useState(0); //380
  const [isshow, setIsshow] = useState(false);

  const [is_device, setIsdevice] = useState(false);
  const [icons, setIcon] = useState([]);
  const [obj_device, setOBJdevice] = useState({
    id: 0,
    name: "",
    icon: "",
    data: [],
  });
  const [data, setData] = useState({
    schedule_mode: "sunrise",
    active: false,
    schedule_name: "",
    icon: "sun",
    icon_id: "6",
    status: true,
    schedule_day: [1, 2, 3, 4, 5, 6, 7],
    schedule_time: "",
    devices: [
      { id: 1, name: "Kitchen", icon: "", data: [] },
      { id: 2, name: "Living Room", icon: "", data: [] },
      { id: 3, name: "Master Bathroom", icon: "", data: [] },
    ],
    scene: "",
  });
  const [selectedKey, setSelectKey] = useState("device");
  const [optionsScenes, setOptionsScenes] = useState([
    {
      label: "Movie",
      value: "movie",
    },
  ]);
  const [devices, setDevices] = useState([
    {
      id: 1,
      name: "Kitchen",
      icon: "",
      data: [
        {
          id: "125313",
          type: {
            name: "erv",
          },
          mode: "auto",
          fan: "low",
          status: "on",
        },
        {
          id: "121355",
          type: {
            name: "doas",
          },
          mode: "auto",
          fan: "mid",
          temp: "25",
        },
        {
          id: "26232",
          type: {
            name: "air",
          },
          status: "on",
          temp: "25",
          mode: "eco",
          fan: "high",
        },
        {
          id: "5622",
          type: {
            name: "lamp",
          },
          status: "on",
          number: "50",
        },
        {
          id: "524242",
          type: {
            name: "chandelier",
          },
          status: "off",
          number: "0",
        },
        {
          id: "6325",
          type: {
            name: "curtain",
          },
        },
      ],
    },
    { id: 2, name: "Living Room", icon: "", data: [] },
  ]);
  const [rooms, setRooms] = useState([]);
  const [scene, setScene] = useState([]);
  const [sceneId, setSceneid] = useState([]);

  var navigate = useNavigate();

  useEffect(() => {
    getIcons();
    getScene();
    getRooms();
    settingWidth();
  }, []);

  const getRooms = () => {
    var data = {
      house_number: myUser.house_number,
      project_id: myUser.project_code,
      unit_number: myUser.unit_number,
    };
    apigetRoom(data, (err, res) => {
      if (res.message === "Success") {
        var rooms = setformatData(res.rooms, "schedule");

        setDevices(rooms);
        setRooms(rooms);
      }
    });
  };

  const getScene = () => {
    var data = {
      house_number: myUser.house_number,
      project_id: myUser.project_code,
      unit_number: myUser.unit_number,
    };

    apigetScene(data, (err, res) => {
      if (res.message === "Success") {
        var scenes_all = res.scenes;
        var plain = [];
        scenes_all.map((e) => {
          plain.push({
            label: e.scene_name,
            value: e.scene_name,
          });
        });
        setScene(scenes_all);
        setOptionsScenes(plain);
      }
    });
  };

  const settingWidth = () => {
    var btn_width = 0;

    if (windowWidth.current <= 400) {
      btn_width = windowWidth.current - 350;
    } else if (windowWidth.current <= 430) {
      btn_width = windowWidth.current - 370;
    } else if (windowWidth.current <= 768) {
      btn_width = windowWidth.current - 530;
    } else if (windowWidth.current <= 1024) {
      btn_width = windowWidth.current - 650;
    }
    setBtnwidth(btn_width);
    setIsshow(true);
  };

  const handleChange = (value) => {
    console.log("handleChange", value);
    var scene_id = [];
    scene.map((e) => {
      if (e.scene_name === value) {
        scene_id.push(e.id);
      }
    });
    setSceneid(scene_id);
  };

  const createSchedule = () => {
    // var setTime = "";
    var seceneId_last = [];
    // if (data.schedule_time.$H === 0 && data.schedule_time.$m === 0) {
    //   setTime = "00:00";
    // } else if (data.schedule_time.$H > 0 && data.schedule_time.$m === 0) {
    //   setTime = data.schedule_time.$H + ":00";
    // } else if (data.schedule_time.$H === 0 && data.schedule_time.$m > 0) {
    //   setTime = "00:" + data.schedule_time.$m;
    // } else if (data.schedule_time.$H > 0 && data.schedule_time.$m > 0) {
    //   var date_hour = "";
    //   var date_minute = "";

    //   if (data.schedule_time.$H < 10) {
    //     date_hour = "0" + data.schedule_time.$H;
    //   } else if (data.schedule_time.$H > 9) {
    //     date_hour = data.schedule_time.$H;
    //   }

    //   if (data.schedule_time.$m < 10) {
    //     date_minute = "0" + data.schedule_time.$m;
    //   } else if (data.schedule_time.$m > 9) {
    //     date_minute = data.schedule_time.$m;
    //   }
    //   setTime = date_hour + ":" + date_minute;
    // }

    if (sceneId.length === 0 && scene.length > 0) {
      seceneId_last.push(scene[0]["id"]);
    } else {
      seceneId_last = sceneId;
    }

    var raw = JSON.stringify({
      active: data.active.toString(),
      schedule_name: data.schedule_name,
      icon_id: data.icon_id,
      house_number: myUser.house_number,
      project_id: myUser.project_code,
      unit_number: myUser.unit_number,
      schedule_mode: data.schedule_mode,
      schedule_time: data.schedule_mode === "time" ? data.schedule_time : "",
      // schedule_time: setTime,
      schedule_day: data.schedule_day,
      schedule_type: selectedKey,
      schedule_scene_id: seceneId_last,
      rooms: devices,
    });

    if (data["schedule_day"].length > 0) {
      apiPostCreateSchedule(raw, (err, res) => {
        if (res.message === "Success") {
          navigate("/schdule");
        }
      });
    }
  };

  const getIcons = () => {
    var data = {
      scenes: "scene",
    };

    apigetIcons(data, (err, res) => {
      if (res.message === "Success") {
        setIcon(res.icons);
      }
    });
  };

  const Set_data = (edit) => {
    var tmp = devices.map((e) => {
      if (e.id === edit.id) {
        return edit;
      } else {
        return e;
      }
    });
    setDevices([...tmp]);
  };
  if (is_device) {
    return (
      <Room_deive
        data={obj_device}
        handleBack={() => {
          setIsdevice(!is_device);
          setOBJdevice({});
        }}
        handleUpdated={(event) => {
          Set_data(event);
          setIsdevice(!is_device);
          setOBJdevice({});
        }}
      />
    );
  } else {
    return (
      <Layout>
        <Content>
          {!isshow ? (
            <div style={styles.reload}>
              <Spin size="large" />
            </div>
          ) : (
            <div className="parentDiv">
              <div className="childDiv">
                <div style={{ backgroundColor: "#FBFBFB", height: "100%" }}>
                  <div name="head" style={styles.head}>
                    <Row style={{ padding: "13px 16px" }}>
                      <Col span={4}>
                        <div
                          onClick={() => {
                            navigate("/schdule");
                          }}
                        >
                          {ScenePicture.backpage()}
                        </div>
                      </Col>
                      <Col span={16} style={styles.textHead}>
                        <div>Add schedule</div>
                      </Col>
                      <Col span={4}></Col>
                    </Row>
                  </div>
                  <div style={styles.bodyPage}>
                    <Row align={"middle"} justify={"space-between"}>
                      <Col>
                        <span style={styles.textSchedule}>Schedule</span>
                      </Col>
                      <Col>
                        <Switch
                          direction="vertical"
                          checkedChildren="ON"
                          unCheckedChildren="OFF"
                          checked={data.active}
                          onClick={() => {
                            setData({ ...data, active: !data.active });
                          }}
                        />
                        &nbsp; &nbsp;
                        <span style={styles.textStatus}>
                          {data.active ? "Active" : "Inactive"}
                        </span>
                      </Col>
                    </Row>
                    <div style={{ marginTop: "16px" }}>
                      <Row>
                        <Col span={7}>
                          <div style={styles.boxPicture}>
                            <div style={{ margin: "16px" }}>
                              <div style={{ textAlign: "center" }}>
                                {icons.map((e) => {
                                  if (parseInt(data.icon_id) === e.id) {
                                    return (
                                      <Image
                                        preview={false}
                                        width={40}
                                        src={e.name}
                                      />
                                    );
                                  }
                                  return <></>;
                                })}
                              </div>
                              <div
                                style={{
                                  textAlign: "center",
                                  whiteSpace: "nowrap",
                                  // width: "50px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {data["schedule_name"] !== ""
                                  ? data["schedule_name"]
                                  : "Name"}
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col span={17}>
                          <div style={{ borderBottom: "1px solid #C0C0C0" }}>
                            <Input
                              placeholder="Name"
                              bordered={false}
                              value={data.schedule_name}
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  schedule_name: e.target.value,
                                });
                              }}
                            />
                          </div>
                          <div
                            style={{
                              overflow: "auto",
                              display: "flex",
                              marginTop: "10px",
                            }}
                          >
                            {icons.map((e, i) => {
                              var colorBg = styles.borderIcon;
                              if (e.id === parseInt(data.icon_id)) {
                                colorBg = styles.borderIconAction;
                              }
                              return (
                                <div style={styles.boxIcon} key={i + "_icon"}>
                                  <div
                                    style={colorBg}
                                    onClick={() => {
                                      setData({
                                        ...data,
                                        icon_id: e["id"].toString(),
                                      });
                                    }}
                                  >
                                    <Image
                                      preview={false}
                                      width={40}
                                      src={e.name}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <Row
                      style={{
                        marginTop: "32px",
                        marginBottom: "32px",
                      }}
                    >
                      <Col span={10}>
                        <Select
                          defaultValue={selectedKey}
                          style={{
                            width: 110,
                          }}
                          options={[
                            {
                              label: "Device",
                              value: "device",
                            },
                            {
                              label: "Scene",
                              value: "scene",
                            },
                          ]}
                          onChange={(e) => {
                            if (e === "device") {
                              setData({ ...data, scene: "" });
                              setSceneid([]);
                            } else {
                              setData({ ...data, devices: [] });
                              setDevices(rooms);
                            }
                            setSelectKey(e);
                          }}
                        />{" "}
                        &nbsp; :
                      </Col>
                      {selectedKey === "scene" && optionsScenes.length > 0 ? (
                        <Col span={14}>
                          <Select
                            defaultValue={optionsScenes[0].value}
                            style={{
                              width: "100%",
                            }}
                            onChange={handleChange}
                            options={optionsScenes}
                          />
                        </Col>
                      ) : null}
                    </Row>
                    {selectedKey === "device" &&
                      devices.map((d) => (
                        <Devicebox
                          data={d}
                          handleSet={(data) => {
                            setOBJdevice(data);
                            setIsdevice(!is_device);
                          }}
                        />
                      ))}
                    <div
                      style={{
                        marginBottom: "16px",
                        color: "rgba(86, 88, 93, 1)",
                        fontFeatureSettings: "clig off, liga off",
                        fontFamily: "Gotham",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: "400",
                        lineHeight: "24px",
                        letterSpacing: "0.4px",
                      }}
                    >
                      Set Schedule
                    </div>

                    <div style={{ margin: "10px 0px 15px 0px" }}>
                      <Radio.Group
                        value={data.schedule_mode}
                        onChange={(e) => {
                          setData({ ...data, schedule_mode: e.target.value });
                        }}
                        style={{ display: "flow" }}
                      >
                        <Row>
                          <Col span={12}>
                            <Radio
                              value={"sunrise"}
                              style={{ marginBottom: 20 }}
                            >
                              <span
                                style={
                                  data.schedule_mode === "sunrise"
                                    ? styles.textTimeChoose
                                    : styles.textTime
                                }
                              >
                                Sunrise
                              </span>
                            </Radio>
                          </Col>
                          <Col span={12}>
                            <Radio value={"sunset"}>
                              <span
                                style={
                                  data.schedule_mode === "sunset"
                                    ? styles.textTimeChoose
                                    : styles.textTime
                                }
                              >
                                Sunset
                              </span>
                            </Radio>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={10}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                height: "100%",
                              }}
                            >
                              <Radio value={"time"}>
                                <span
                                  style={
                                    data.schedule_mode === "time"
                                      ? styles.textTimeChoose
                                      : styles.textTime
                                  }
                                >
                                  Specific Time
                                </span>
                              </Radio>
                            </div>
                          </Col>
                          <Col span={14}>
                            <Row>
                              <Col span={12}>
                                <div>
                                  {data.schedule_mode === "time" && (
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                      style={{ padding: "12px 10px" }}
                                    >
                                      <MobileTimePicker
                                        defaultValue={dayjs("2022-04-17T08:00")}
                                        onChange={(value) => {
                                          setData({
                                            ...data,
                                            schedule_time: moment(
                                              value.$d
                                            ).format("HH:mm"),
                                          });
                                        }}
                                      />
                                    </LocalizationProvider>
                                    // <DatePicker
                                    //   defaultValue={moment().startOf("day")}
                                    //   size={"large"}
                                    //   picker={"time"}
                                    //   format="HH : mm"
                                    //   autoFocus={true}
                                    //   onChange={(value) => {
                                    //     setData({ ...data, schedule_time: value });
                                    //   }}
                                    // />
                                  )}
                                </div>
                              </Col>
                              <Col span={12}></Col>
                            </Row>
                          </Col>
                        </Row>
                      </Radio.Group>
                    </div>
                    <div
                      style={{
                        color: "rgba(86, 88, 93, 1)",
                        fontFeatureSettings: "clig off, liga off",
                        fontFamily: "Gotham",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: "400",
                        lineHeight: "24px",
                        letterSpacing: "0.4px",
                        marginBottom: "16px",
                      }}
                    >
                      Day
                    </div>
                    <Row gutter={[16, 2]}>
                      {new Array(7).fill(null).map((_, i) => {
                        const id = i + 1;
                        return (
                          <Col span={12} style={{ marginBottom: "16px" }}>
                            <Switch
                              checked={
                                data.schedule_day.find((d) => d === i + 1)
                                  ? true
                                  : false
                              }
                              onClick={(e) => {
                                if (e) {
                                  setData({
                                    ...data,
                                    schedule_day: data.schedule_day.concat(
                                      i + 1
                                    ),
                                  });
                                } else {
                                  setData({
                                    ...data,
                                    schedule_day: data.schedule_day.filter(
                                      (d) => d !== i + 1
                                    ),
                                  });
                                }
                              }}
                            />{" "}
                            &nbsp; {moment().day(id).format("dddd")}{" "}
                          </Col>
                        );
                      })}
                    </Row>
                    <div style={{ height: "80px" }}></div>
                    <ConfigProvider
                      theme={{
                        token: {
                          colorBgElevated: "#3EA8B8",
                          colorText: "white",
                        },
                      }}
                    >
                      <FloatButton
                        style={{
                          left: `${btnwidth}px`,
                          display: "flex",
                          width: "312px",
                          height: "48px",
                          flexShrink: "0",
                          borderRadius: "8px",
                        }}
                        onClick={() => {
                          createSchedule();
                        }}
                        description={
                          <div style={styles.textInbtnA}>create schedule</div>
                        }
                      />
                    </ConfigProvider>
                    {/* <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "10px",
                  marginBottom: "50px",
                }}
              >
                <button
                  style={styles.btnCreateActton}
                  onClick={() => {
                    createSchedule();
                    // data + devices
                  }}
                >
                  <div style={styles.textInbtnA}>create schedule</div>
                </button>
              </div> */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </Content>
      </Layout>
    );
  }
}

const styles = {
  // underlineSchedule: {
  //   backgroundColor: "#919499",
  //   opacity: "0.2",
  //   marginTop: "10px",
  // },
  head: {
    backgroundColor: "#F0F9FB",
    height: "56px",
  },
  textHead: {
    color: "#3EA8B8",
    textAlign: "center",
    fontFeatureSettings: "clig off, liga off",
    fontFamily: "Gotham",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "350",
    lineHeight: "30px",
    letterSpacing: "0.15px",
  },
  bodyPage: {
    backgroundColor: "#FBFBFB",
    padding: "20px 15px 20px 15px",
  },
  boxPicture: {
    width: "96px",
    height: "96px",
    flexShrink: "0",
    borderRadius: "16px",
    border: "1px solid var(--primary-meadows-100, #B5EAEF)",
    background: "var(--text-on-dark-area",
  },
  textSchedule: {
    color: "rgba(86, 88, 93, 1)",
    fontFeatureSettings: "clig off, liga off",
    fontFamily: "Gotham",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "24px",
    letterSpacing: "0.4px",
  },
  textInbtnA: {
    color: "#FBFBFB",
    textAlign: "center",
    fontFeatureSettings: "clig off, liga off",
    // fontFamily: "Gotham",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "21px",
    letterSpacing: "1px",
    textTransform: "uppercase",
  },
  textStatus: {
    color: "#56585D",
    textAlign: "right",
    fontFamily: "Gotham",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "normal",
  },
  boxIcon: {
    width: "52px",
    height: "52px",
    margin: "0 5px",
  },
  borderIcon: {
    width: "42px",
    height: "42px",
    border: "1px solid var(--primary-meadows-100, #B5EAEF)",
    borderRadius: "50%",
    display: "inline-block",
    backgroundColor: "#FFF",
  },
  borderIconAction: {
    width: "42px",
    height: "42px",
    border: "1px solid var(--primary-meadows-100, #B5EAEF)",
    borderRadius: "50%",
    display: "inline-block",
    backgroundColor: "#EBF4FA",
  },
  btnCreateActton: {
    display: "flex",
    width: "360px",
    height: "48px",
    padding: "9px 0px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "8px",
    border: "1px solid #3EA8B8",
    backgroundColor: "#3EA8B8",
    color: "#FBFBFB",
    fontSize: "14px",
    fontFamily: "Gotham",
    fontWeight: "350",
    lineHeight: "21px",
  },
  textTime: {
    // fontFamily: "Gotham",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "21px",
    letterSpacing: "0px",
    color: "#919499",
  },
  textTimeChoose: {
    // fontFamily: "Gotham",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "21px",
    letterSpacing: "0px",
    color: "#56585D",
  },
  reload: {
    margin: "20px 0",
    marginBottom: "20px",
    padding: "30px 50px",
    textAlign: "center",
    borderRadius: "4px",
    display: "inherit",
  },
};
